import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import cn from 'classnames';

import { 
  getDislikedProducts, 
  findDislikedProductsIngredients,
  addDislikedProductIngredient,
  deleteDislikedProductIngredient,
  deleteDislikedProduct,
 } from '../../actions/product';
import { getIngredients } from '../../actions/ingredient';
import DislikedProductsModal from '../../components/DislikedProductModal/DislikedProductModal';
import styles from './DislikedProducts.module.css';

const DislikedProducts = (props) => {
  const { 
    getDislikedProducts,
    getIngredients,
    findDislikedProductsIngredients,
    dislikedProductsData,
    ingredientsData,
    addDislikedProductIngredient,
    deleteDislikedProductIngredient,
    deleteDislikedProduct,
   } = props;

  const [showModal, setShowModal] = useState(false);
  const [initialValue, setInitialValue] = useState(null);
  const [addIngredientId, setAddIngredientId] = useState(null);
  const [selectedIngredient, setSelectedIngredient] = useState('');

  useEffect(() => {
    getDislikedProducts();
    getIngredients();
  }, []);

  const openModalHandler = () => {
    setInitialValue(null);
    setShowModal(true);
  };

  const findIngredients = (productId) => {
    const confirmResult = window.confirm('Are you sure?');

    if (!confirmResult) {
      return;
    }

    findDislikedProductsIngredients(productId);
  };

  const addIngredient = () => {
    if (!selectedIngredient) {
      return toast.error('You must select ingredient', {
        position: 'bottom-right',
        duration: 3000,
      });
    }

    const ingredientData = {
      disliked_product_id: addIngredientId,
      ingredient_id: selectedIngredient,
    };

    addDislikedProductIngredient(ingredientData, () => {
      setAddIngredientId(null);
      setSelectedIngredient('');
      toast.success('Success', {
        position: 'bottom-right',
        duration: 3000,
      });
    });

    console.log('===INGREDIENT ID', selectedIngredient);
  };

  const deleteIngredient = (dislikedProductId, ingredientId) => {
    const confirmResult = window.confirm('Are you sure?');

    if (!confirmResult) {
      return;
    }

    const ingredientData = {
      disliked_product_id: dislikedProductId,
      ingredient_id: ingredientId,
    };

    deleteDislikedProductIngredient(ingredientData, () => {
      toast.success('Success', {
        position: 'bottom-right',
        duration: 3000,
      });
    });

    console.log('===DELETE', dislikedProductId, ingredientId);
  };

  const editHandler = (productData) => {
    setInitialValue(productData);
    setShowModal(true);
  };

  const deleteHandler = (id) => {
    const confirmResult = window.confirm('Are you sure?');

    if (confirmResult) {
      deleteDislikedProduct(id);
    }
  };
  
  const renderAddIngredientButton = (productId) => {
    if (productId === addIngredientId) {
      return (
        <div className={styles.selectWrapper}>
          <select 
            className={styles.select}
            value={selectedIngredient}
            onChange={({ target }) => {
              setSelectedIngredient(target.value);
            }}
          >
            <option value="" disabled >Select ingredient</option>
            {ingredientsData?.map((ingredient) => (
              <option
                key={ingredient.id} 
                value={ingredient.id}
              >
                {ingredient.name} ({ingredient.unit_type})
              </option>
            ))}
          </select>
          <div 
            className={styles.selectButton}
            onClick={addIngredient}
          >
            +
          </div>
        </div>
      );
    }


    return (
      <button 
        className="button yellow-button" 
        onClick={() => setAddIngredientId(productId)}
      >
        Add Ingredient
      </button>
    );
  };

  return (
    <div className="wrapper">
      <DislikedProductsModal 
        key={initialValue?.id}
        isOpen={showModal} 
        onClose={() => setShowModal(false)}
        initialValue={initialValue}
      />
      <div className={styles.tools}>
        <h1>
          Disliked Products
        </h1>
        <div className={styles.buttons}>
          <div className={styles.addDish} onClick={openModalHandler}>
            Add disliked product
          </div>
        </div>
      </div>
      <table className={cn(styles.table, 'table')}>
        <thead>
        <tr>
          <th>Id</th>
          <th>Name</th>
          <th>Ingredients</th>
          <th>Controls</th>
        </tr>
        </thead>
        <tbody>
        {dislikedProductsData?.map((dislikedProductItem) => (
          <tr key={dislikedProductItem.id}>
            <td>
              {dislikedProductItem.id}
            </td>
            <td>
              {dislikedProductItem.name}
            </td>
            <td>
              {dislikedProductItem.ingredients?.map((ingredient) => (
                <div className={styles.ingredient} key={ingredient.id}>
                  {ingredient.name} ({ingredient.unit_type})
                  <div 
                    className={styles.deleteIngredient}
                    onClick={() => deleteIngredient(dislikedProductItem.id, ingredient.id)}
                  >
                    ×
                  </div>
                </div>
              ))}
            </td>
            <td>
              <div className={styles.controls}>
                <button className="button green-button" onClick={() => editHandler(dislikedProductItem)}>
                  Edit
                </button>
                <button className="button red-button" onClick={() => deleteHandler(dislikedProductItem.id)}>
                  Delete
                </button>
                <button 
                  className="button blue-button" 
                  onClick={() => findIngredients(dislikedProductItem.id)}
                >
                  Find Matching Ingredients
                </button>
                {renderAddIngredientButton(dislikedProductItem.id)}
              </div>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  dislikedProductsData: store.product.dislikedProductsData,
  ingredientsData: store.ingredient.ingredientsData,
});

const mapDispatchToProps = {
  getDislikedProducts,
  getIngredients,
  findDislikedProductsIngredients,
  addDislikedProductIngredient,
  deleteDislikedProductIngredient,
  deleteDislikedProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(DislikedProducts);